import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import { Error } from '../_models/auth.models';
import {
  AddPagePayload,
  AddPageResponse,
  Company,
  DomainPayload,
  Pages,
  RequestCompanyDatatable,
} from '../_models/company.model';
import { Datatable, RequestDatatable } from '../_models/report.models';
import { CopyAppPayload } from '../_models/settings.models';

/**
 * Company action types
 */

export enum CompanyActionTypes {
  LOAD = '[Company] Load',
  LOAD_SUCCESS = '[Company] Load Success',
  LOAD_FAILED = '[Company] Load Failed',
  LOAD_DATATABLE = '[Company] Load Datatable',
  LOAD_DATATABLE_SUCCESS = '[Company] Load Datatable Success',
  LOAD_DATATABLE_FAILED = '[Company] Load Datatable Failed',
  LOAD_USERS_DATATABLE = '[Company] Load Users Datatable',
  LOAD_USERS_DATATABLE_SUCCESS = '[Company] Load Users Datatable Success',
  LOAD_USERS_DATATABLE_FAILED = '[Company] Load Users Datatable Failed',
  GET_COMPANY = '[Company] Get Company',
  GET_COMPANY_SUCCESS = '[Company] Get Company Success',
  GET_COMPANY_FAILED = '[Company] Get Company Failed',
  UPDATE_COMPANY = '[Company] Update Company',
  UPDATE_COMPANY_SUCCESS = '[Company] Update Company Success',
  UPDATE_COMPANY_FAILED = '[Company] Update Company Failed',
  DELETE_COMPANY = '[Company] Delete Company',
  DELETE_COMPANY_SUCCESS = '[Company] Delete Company Success',
  DELETE_COMPANY_FAILED = '[Company] Delete Company Failed',
  CANCEL_COMPANY_SUBSCRIPTION = '[Company] Cancel Company Subscription',
  CANCEL_COMPANY_SUBSCRIPTION_SUCCESS = '[Company] Cancel Company Subscription Success',
  CANCEL_COMPANY_SUBSCRIPTION_FAILED = '[Company] Cancel Company Subscription Failed',
  ADD_PAYMENT_METHOD = '[Company] Add Payment Method',
  ADD_PAYMENT_METHOD_SUCCESS = '[Company] Add Payment Method Success',
  ADD_PAYMENT_METHOD_FAILED = '[Company] Add Payment Method Failed',
  LOAD_CROSS_DOMAIN_COMPANIES = '[Company] Get Cross Domain Companies',
  LOAD_CROSS_DOMAIN_COMPANIES_SUCCESS = '[Company] Get Cross Domain Companies Success',
  LOAD_CROSS_DOMAIN_COMPANIES_FAILED = '[Company] Get Cross Domain Companies Failed',
  CHECK_DOMAIN_VALIDATION = '[Company] Check domain Validity',
  CHECK_DOMAIN_VALIDATION_SUCCESS = '[Field] Check domain Validity Success',
  CHECK_DOMAIN_VALIDATION_FAILED = '[Field] Check domain Validity Failed',
  REQUEST_DOMAIN = '[Company] Request Domain',
  REQUEST_DOMAIN_SUCCESS = '[Field] Request Domain Success',
  REQUEST_DOMAIN_FAILED = '[Field] Request Domain Failed',
  CHECK_DOMAIN_STATUS = '[Company] Check Domain Status',
  CHECK_DOMAIN_STATUS_SUCCESS = '[Field] Check Domain Status Success',
  CHECK_DOMAIN_STATUS_FAILED = '[Field] Check Domain Status Failed',
  DELETE_PAGE = '[Company] Delete Page',
  DELETE_PAGE_SUCCESS = '[Field] Delete Page Success',
  DELETE_PAGE_FAILED = '[Field] Delete Page Failed',
  ADD_PAGE = '[Company] Add Page',
  ADD_PAGE_SUCCESS = '[Field] Add Page Success',
  ADD_PAGE_FAILED = '[Field] Add Page Failed',
  UPDATE_PAGE = '[Company] Update Page',
  UPDATE_PAGE_SUCCESS = '[Field] Update Page Success',
  UPDATE_PAGE_FAILED = '[Field] Update Page Failed',
  UPDATE_COMPANY_TOGGLE = '[Company] Update Compnay Toggle',
  UPDATE_COMPANY_TOGGLE_SUCCESS = '[Field] Update Compnay Toggle Success',
  UPDATE_COMPANY_TOGGLE_FAILED = '[Field] Update Compnay Toggle Failed',
  RESET = '[Company] RESET',
}

/**
 * Operations
 */

export class DeleteCompany extends Reference implements Action {
  readonly type = CompanyActionTypes.DELETE_COMPANY;

  constructor(public companyId: number) {
    super();
  }
}

export class DeleteCompanySuccess extends Reference implements Action {
  readonly type = CompanyActionTypes.DELETE_COMPANY_SUCCESS;

  constructor(public response: any) {
    super();
  }
}

export class DeleteCompanyFailed extends Reference implements Action {
  readonly type = CompanyActionTypes.DELETE_COMPANY_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class UpdateCompany extends Reference implements Action {
  readonly type = CompanyActionTypes.UPDATE_COMPANY;

  constructor(public payload: any) {
    super();
  }
}

export class UpdateCompanySuccess extends Reference implements Action {
  readonly type = CompanyActionTypes.UPDATE_COMPANY_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class UpdateCompanyFailed extends Reference implements Action {
  readonly type = CompanyActionTypes.UPDATE_COMPANY_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class UpdateCompanyToggle extends Reference implements Action {
  readonly type = CompanyActionTypes.UPDATE_COMPANY_TOGGLE;

  constructor(public companyId:any, public payload: any) {
    super();
  }
}

export class UpdateCompanyToggleSuccess extends Reference implements Action {
  readonly type = CompanyActionTypes.UPDATE_COMPANY_TOGGLE_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class UpdateCompanyToggleFailed extends Reference implements Action {
  readonly type = CompanyActionTypes.UPDATE_COMPANY_TOGGLE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class CancelCompanySubscription implements Action {
  readonly type = CompanyActionTypes.CANCEL_COMPANY_SUBSCRIPTION;

  constructor(public companyId: number) {}
}

export class CancelCompanySubscriptionSuccess implements Action {
  readonly type = CompanyActionTypes.CANCEL_COMPANY_SUBSCRIPTION_SUCCESS;

  constructor(public payload: any) {}
}

export class CancelCompanySubscriptionFailed implements Action {
  readonly type = CompanyActionTypes.CANCEL_COMPANY_SUBSCRIPTION_FAILED;

  constructor(public payload: Error) {}
}

export class AddPaymentMethod implements Action {
  readonly type = CompanyActionTypes.ADD_PAYMENT_METHOD;

  constructor(
    public customerId: string,
    public paymentMethodId: string,
    public isDefaultMethod: boolean
  ) {}
}

export class AddPaymentMethodSuccess implements Action {
  readonly type = CompanyActionTypes.ADD_PAYMENT_METHOD_SUCCESS;

  constructor(public payload: any) {}
}

export class AddPaymentMethodFailed implements Action {
  readonly type = CompanyActionTypes.ADD_PAYMENT_METHOD_FAILED;

  constructor(public payload: Error) {}
}

export class LoadCompanies implements Action {
  readonly type = CompanyActionTypes.LOAD;

  constructor() {}
}

export class LoadCompaniesSuccess implements Action {
  readonly type = CompanyActionTypes.LOAD_SUCCESS;

  constructor(public payload: Array<Company>) {}
}

export class LoadCompaniesFailed implements Action {
  readonly type = CompanyActionTypes.LOAD_FAILED;

  constructor(public payload: Error) {}
}

export class GetCrossDomainCompanies implements Action {
  readonly type = CompanyActionTypes.LOAD_CROSS_DOMAIN_COMPANIES;

  constructor(public payload: CopyAppPayload) {}
}

export class GetCrossDomainCompaniesSuccess implements Action {
  readonly type = CompanyActionTypes.LOAD_CROSS_DOMAIN_COMPANIES_SUCCESS;

  constructor(public payload: any) {}
}

export class GetCrossDomainCompaniesFailed implements Action {
  readonly type = CompanyActionTypes.LOAD_CROSS_DOMAIN_COMPANIES_FAILED;

  constructor(public payload: any) {}
}

export class GetCompany implements Action {
  readonly type = CompanyActionTypes.GET_COMPANY;

  constructor(public companyId: number) {}
}

export class GetCompanySuccess implements Action {
  readonly type = CompanyActionTypes.GET_COMPANY_SUCCESS;

  constructor(public companyId: number, public payload: any) {}
}

export class GetCompanyFailed implements Action {
  readonly type = CompanyActionTypes.GET_COMPANY_FAILED;

  constructor(public payload: Error) {}
}

export class LoadCompaniesDatatable implements Action {
  readonly type = CompanyActionTypes.LOAD_DATATABLE;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public payload: RequestCompanyDatatable,
    public force: boolean = false
  ) {}
}

export class LoadCompaniesDatatableSuccess implements Action {
  readonly type = CompanyActionTypes.LOAD_DATATABLE_SUCCESS;

  /**
   * @param start start from (from request payload)
   * @param length page size (from request payload)
   */
  constructor(
    public start: number,
    public length: number,
    public payload: Datatable
  ) {}
}

export class LoadCompaniesDatatableFailed implements Action {
  readonly type = CompanyActionTypes.LOAD_DATATABLE_FAILED;

  constructor(public payload: Error) {}
}

export class LoadCompanyUsersDatatable implements Action {
  readonly type = CompanyActionTypes.LOAD_USERS_DATATABLE;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(
    public payload: RequestCompanyDatatable,
    public force: boolean = false
  ) {}
}

export class LoadCompanyUsersDatatableSuccess implements Action {
  readonly type = CompanyActionTypes.LOAD_USERS_DATATABLE_SUCCESS;

  /**
   * @param start start from (from request payload)
   * @param length page size (from request payload)
   */
  constructor(
    public companyId: string,
    public start: number,
    public length: number,
    public payload: Datatable
  ) {}
}

export class LoadCompanyUsersDatatableFailed implements Action {
  readonly type = CompanyActionTypes.LOAD_USERS_DATATABLE_FAILED;

  constructor(public payload: Error) {}
}
export class CheckDomainValidity extends Reference implements Action {
  readonly type = CompanyActionTypes.CHECK_DOMAIN_VALIDATION;

  constructor(public companyId: any, public payload: DomainPayload) {
    super();
  }
}

export class CheckDomainValiditySuccess extends Reference implements Action {
  readonly type = CompanyActionTypes.CHECK_DOMAIN_VALIDATION_SUCCESS;

  constructor(public companyId:any,public payload: any) {
    super();
  }
}

export class CheckDomainValidityFailed extends Reference implements Action {
  readonly type = CompanyActionTypes.CHECK_DOMAIN_VALIDATION_FAILED;

  constructor(public payload: any) {
    super();
  }
}
export class RequestDomain extends Reference implements Action {
  readonly type = CompanyActionTypes.REQUEST_DOMAIN;

  constructor(public companyId: any, public payload: DomainPayload) {
    super();
  }
}

export class RequestDomainSuccess extends Reference implements Action {
  readonly type = CompanyActionTypes.REQUEST_DOMAIN_SUCCESS;

  constructor(public companyId: any, public payload: any) {
    super();
  }
}

export class RequestDomainFailed extends Reference implements Action {
  readonly type = CompanyActionTypes.REQUEST_DOMAIN_FAILED;

  constructor(public payload: any) {
    super();
  }
}
export class CheckDomainStatus extends Reference implements Action {
  readonly type = CompanyActionTypes.CHECK_DOMAIN_STATUS;

  constructor(public companyId: any, public payload: any) {
    super();
  }
}

export class CheckDomainStatusSuccess extends Reference implements Action {
  readonly type = CompanyActionTypes.CHECK_DOMAIN_STATUS_SUCCESS;

  constructor(public companyId:any, public payload: any) {
    super();
  }
}

export class CheckDomainStatusFailed extends Reference implements Action {
  readonly type = CompanyActionTypes.CHECK_DOMAIN_STATUS_FAILED;

  constructor(public payload: any) {
    super();
  }
}

export class DeletePage extends Reference implements Action {
  readonly type = CompanyActionTypes.DELETE_PAGE;

  constructor(public pageId: string, public companyId: any) {
    super();
  }
}

export class DeletePageSuccess extends Reference implements Action {
  readonly type = CompanyActionTypes.DELETE_PAGE_SUCCESS;

  constructor(public pageId: string, public companyId: string) {
    super();
  }
}

export class DeletePageFailed extends Reference implements Action {
  readonly type = CompanyActionTypes.DELETE_PAGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class AddPage extends Reference implements Action {
  readonly type = CompanyActionTypes.ADD_PAGE;

  constructor(public companyId:any,public payload: AddPagePayload) {
    super();
  }
}

export class AddPageSuccess extends Reference implements Action {
  readonly type = CompanyActionTypes.ADD_PAGE_SUCCESS;

  constructor(public payload: AddPageResponse) {
    super();
  }
}

export class AddPageFailed extends Reference implements Action {
  readonly type = CompanyActionTypes.ADD_PAGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}


export class UpdatePage extends Reference implements Action {
  readonly type = CompanyActionTypes.UPDATE_PAGE;

  constructor(public companyId:any,public payload: AddPagePayload) {
    super();
  }
}

export class UpdatePageSuccess extends Reference implements Action {
  readonly type = CompanyActionTypes.UPDATE_PAGE_SUCCESS;

  constructor(public payload: Pages) {
    super();
  }
}

export class UpdatePageFailed extends Reference implements Action {
  readonly type = CompanyActionTypes.UPDATE_PAGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}


/**
 * Operations
 */

export class Reset implements Action {
  readonly type = CompanyActionTypes.RESET;

  constructor() {}
}

/**
 * Available types
 */
export type Actions =
  | LoadCompanies
  | LoadCompaniesSuccess
  | LoadCompaniesFailed
  | GetCrossDomainCompanies
  | GetCrossDomainCompaniesSuccess
  | GetCrossDomainCompaniesFailed
  | LoadCompaniesDatatable
  | LoadCompaniesDatatableSuccess
  | LoadCompaniesDatatableFailed
  | LoadCompanyUsersDatatable
  | LoadCompanyUsersDatatableSuccess
  | LoadCompanyUsersDatatableFailed
  | GetCompany
  | GetCompanySuccess
  | GetCompanyFailed
  | AddPaymentMethod
  | AddPaymentMethodSuccess
  | AddPaymentMethodFailed
  | UpdateCompany
  | UpdateCompanySuccess
  | UpdateCompanyFailed
  | UpdateCompanyToggle
  | UpdateCompanyToggleSuccess
  | UpdateCompanyToggleFailed
  | DeleteCompany
  | DeleteCompanySuccess
  | DeleteCompanyFailed
  | CancelCompanySubscription
  | CancelCompanySubscriptionSuccess
  | CancelCompanySubscriptionFailed
  | CheckDomainValidity
  | CheckDomainValiditySuccess
  | CheckDomainValidityFailed
  | RequestDomain
  | RequestDomainSuccess
  | RequestDomainFailed
  | CheckDomainStatus
  | CheckDomainStatusSuccess
  | CheckDomainStatusFailed
  | AddPage
  | AddPageSuccess
  | AddPageFailed
  | UpdatePage
  | UpdatePageSuccess
  | UpdatePageFailed
  | DeletePage
  | DeletePageSuccess
  | DeletePageFailed
  | Reset;
